<app-navbar title="Segmenty">
	<button mat-raised-button color="primary" (click)="openAddSegmentPage()">Dodaj segment</button>
</app-navbar>

@if (responsibleUserHasChanged()) {
	<div class="alert alert-warning m-3 text-center" role="alert">
		Zmieniono osobę odpowiedzialną, aby zobaczyć zmiany odśwież stronę!
	</div>
}

<section class="m-3">
	<div class="segments-table-wrapper">
		<table mat-table [dataSource]="segments()" multiTemplateDataRows class="w-100">
			<ng-container matColumnDef="id">
				<th mat-header-cell *matHeaderCellDef>Id</th>
				<td mat-cell *matCellDef="let element">{{ element.id }}</td>
			</ng-container>

			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef>Nazwa</th>
				<td mat-cell *matCellDef="let element">{{ element.name }}</td>
			</ng-container>

			<ng-container matColumnDef="transportTerms">
				<th mat-header-cell *matHeaderCellDef>Liczba terminów</th>
				<td mat-cell *matCellDef="let element">{{ element.transportTerms?.length ?? 0 }}</td>
			</ng-container>

			<ng-container matColumnDef="expand">
				<th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
				<td mat-cell *matCellDef="let element">
					<button
						class="me-2"
						mat-icon-button
						color="primary"
						matTooltip="Listy"
						aria-label="listy segmentu"
						(click)="openSegmentListsPage(element.id); $event.stopPropagation()"
					>
						<i class="fa-solid fa-list"></i>
					</button>
					<button
						class="me-2"
						mat-icon-button
						color="primary"
						matTooltip="Pliki"
						aria-label="pliki segmentu"
						(click)="openSegmentFilesDialog(element.id); $event.stopPropagation()"
					>
						<i class="fa-solid fa-paperclip"></i>
					</button>
					<button
						class="me-2"
						mat-icon-button
						color="primary"
						matTooltip="Edytuj segment"
						aria-label="edytuj segment"
						(click)="openEditSegmentPage(element.id); $event.stopPropagation()"
					>
						<i class="fa-solid fa-pen"></i>
					</button>
					<button
						mat-icon-button
						aria-label="expand row"
						(click)="toggle(element); $event.stopPropagation()"
						class="segments-toggle-button"
						[class.segments-toggle-button-expanded]="isExpanded(element)"
					>
						<i class="fa-solid fa-chevron-down"></i>
					</button>
				</td>
			</ng-container>

			<ng-container matColumnDef="expandedDetail">
				<td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
					<div
						class="segments-element-detail-wrapper"
						[class.segments-element-detail-wrapper-expanded]="isExpanded(element)"
					>
						<div class="segments-element-detail">
							@if (isSegmentTermsLoading(element.id)) {
								<div class="p-3">Ładowanie...</div>
							} @else {
								<app-bag-transport-term-table
									[embeddedData]="getSegmentTerms(element.id)"
									[showPaginator]="false"
									[showCheckboxes]="false"
									[parameters]="tableParameters()"
									(deadlineChanged)="deadlineChanged()"
									(responsibleUserHasChanged)="onResponsibleUserHasChanged($event)"
								></app-bag-transport-term-table>
							}
						</div>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
			<tr
				mat-row
				*matRowDef="let element; columns: columnsToDisplayWithExpand"
				class="segments-element-row"
				[class.segments-expanded-row]="isExpanded(element)"
				(click)="toggle(element)"
			></tr>
			<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="segments-detail-row"></tr>
		</table>
	</div>

	<mat-paginator
		[length]="allItemsSize()"
		[pageIndex]="page()"
		[pageSize]="pageSize()"
		[pageSizeOptions]="[5, 10, 25, 50]"
		(page)="pageChanged($event)"
		showFirstLastButtons
	></mat-paginator>
</section>
